import { Paper, Flex, Title, Text, Anchor, Stack, Image } from '@mantine/core';
import { Link } from 'react-router-dom';

import KTLogo from '../../assets/images/kt_logo.png';

import classes from './AuthFormCard.module.scss';
import MobileAppLinks from '../MobileAppLinks';

interface AuthFormCardProps extends React.ComponentPropsWithoutRef<'div'> {
  title: string;
  logo?: string;
  logoAlt?: string;
  subTitle?: string;
  showSignUpPrompt?: boolean;
  showLogInPrompt?: boolean;
}

function SignUpText() {
  return (
    <div>
      <Text>
        Don&apos;t have an account?{' '}
        <Anchor component={Link} to="/signup">
          Sign up
        </Anchor>
      </Text>
    </div>
  );
}

function LogInText() {
  return (
    <div>
      <Text>
        Already have an account?{' '}
        <Anchor component={Link} to="/login">
          Log In
        </Anchor>
      </Text>
    </div>
  );
}

export default function AuthFormCard({
  children,
  title,
  logo = undefined,
  logoAlt = undefined,
  subTitle = undefined,
  showSignUpPrompt = false,
  showLogInPrompt = false,
}: AuthFormCardProps) {
  return (
    <Paper className={classes.root}>
      <Stack>
        <Flex justify="center">
          <Image
            src={logo || KTLogo}
            alt={logoAlt || 'Kakitangan Logo'}
            w={240}
          />
        </Flex>
        <Title order={2}>{title}</Title>
        {subTitle ? <Title order={3}>{subTitle}</Title> : null}
        {children}
        {showSignUpPrompt && <SignUpText />}
        {showLogInPrompt && <LogInText />}
      </Stack>
      <MobileAppLinks />
    </Paper>
  );
}
